import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 21C7.428 21 3.475 18.17.14 12.508a1 1 0 0 1 0-1.016C3.475 5.831 7.428 3 12 3c4.572 0 8.525 2.83 11.86 8.492a1 1 0 0 1 0 1.016C20.525 18.169 16.572 21 12 21zm0-1c4.172 0 7.828-2.617 10.998-8C19.828 6.617 16.172 4 12 4S4.172 6.617 1.002 12c3.17 5.383 6.826 8 10.998 8zm0-10.5a2.5 2.5 0 0 0 4.78 1.028 5 5 0 1 1-3.307-3.307A2.5 2.5 0 0 0 12 9.5zM8 12a4 4 0 0 0 7.94.69 3.5 3.5 0 0 1-4.63-4.63A4.001 4.001 0 0 0 8 12z"
});

var SvgView = function SvgView(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgView;